<template>
  <!--快速建题规范-->
  <yxt-drawer
    ref="drawerExample"
    :wrapperClosable="false"
    :modal="false"
    :title="$t('pc_biz_ote_lbl_templatesample' /** 标准格式示例 */)"
    :visible.sync="states.isShowStandardFormatExample"
    size="640px"
    :direction="direction"
    :before-close="close"
  >
    <div class="yxtbiz-ai-create-ques-temp yxtbiz-intelligent-questioning">
      <div class="yxtbiz-ai-create-ques-temp__desc">
        <div class="standard-size-12 color-gray-10 yxt-weight-5">
          {{ $t('pc_biz_ote_lbl_desctemplate' /** 规范说明 */) }}
        </div>
        <ul
          class="yxtbiz-ai-create-ques-temp__desc-list"
          :class="
            !isShowMore ? 'yxtbiz-ai-create-ques-temp__desc-list--simple' : ''
          "
        >
          <li v-for="tip in quickTips" :key="tip">
            {{ tip }}
          </li>
        </ul>
        <div class="pl20 mt4">
          <yxt-button type="text" @click="isShowMore = !isShowMore">
            <span>{{
              isShowMore
                ? $t('pc_biz_ote_btn_putaway')
                : $t('pc_biz_ote_btn_expand')
            }}</span>
            <span
              class="ml3"
              :class="isShowMore ? 'yxt-icon-arrow-up' : 'yxt-icon-arrow-down'"
            ></span>
          </yxt-button>
        </div>
      </div>
      <div class="standard-size-12 color-gray-10 yxt-weight-5 mt24">
        {{ $t('pc_biz_ote_lbl_questemplate' /** 题型示例 */) }}
      </div>
      <div class="yxtbiz-ai-create-ques-temp__example mt8">
        <yxt-tabs v-model="quesType" @tab-click="handleClick">
          <yxt-tab-pane
            :key="'-1'"
            :label="$t('pc_biz_ote_lbl_allquestype' /** 全部题型 */)"
            :name="'-1'"
          ></yxt-tab-pane>
          <yxt-tab-pane
            v-for="(item, index) in QUES_TYPE_NAMES.filter((e, i) => i < 5)"
            :key="index"
            :label="$t(item)"
            :name="index + ''"
          ></yxt-tab-pane>
        </yxt-tabs>
        <div class="mt8 mh24 color-gray-9 mb24">
          <!--单选题-->
          <div
            v-if="['-1', '0'].includes(quesType)"
            class="yxtbiz-ai-create-ques-temp__ques"
          >
            <div>
              <!--[单选题][难]下面哪一项不属于面向对象的特性。-->
              [{{ $t('pc_biz_ote_lbl_questype0') }}][{{
                $t('pc_biz_ote_lbl_difficult')
              }}]{{ $t('pc_biz_ote_lbl_quickques01') }}
            </div>
            <div>
              <!--封装性-->
              A. {{ $t('pc_biz_ote_lbl_quickques02') }}
            </div>
            <div>
              <!--原子性-->
              B. {{ $t('pc_biz_ote_lbl_quickques03') }}
            </div>
            <div>
              <!--继承性-->
              C. {{ $t('pc_biz_ote_lbl_quickques04') }}
            </div>
            <div>
              <!--多态性-->
              D. {{ $t('pc_biz_ote_lbl_quickques05') }}
            </div>
            <div>
              <!-- 答案: B -->
              {{ $t('pc_biz_ote_lbl_itemanswer') }}: B
            </div>
            <div>
              <!-- 解析: 原子性不是面对对象的特性 -->
              {{ $t('pc_biz_ote_lbl_quesanalyze') }}:
              {{ $t('pc_biz_ote_lbl_quickquesanalyze2') }}
            </div>
            <br v-if="quesType=== '-1'"/>
          </div>
          <!--多选题-->
          <div
            v-if="['-1', '1'].includes(quesType)"
            class="yxtbiz-ai-create-ques-temp__ques"
          >
            <div>
              <!--[多选题][中]下面哪些项属于面向对象的特性。-->
              [{{ $t('pc_biz_ote_lbl_questype1') }}][{{
                $t('pc_biz_ote_lbl_medium')
              }}]{{ $t('pc_biz_ote_lbl_quickques06') }}
            </div>
            <div>
              <!--封装性-->
              A. {{ $t('pc_biz_ote_lbl_quickques02') }}
            </div>
            <div>
              <!--原子性-->
              B. {{ $t('pc_biz_ote_lbl_quickques03') }}
            </div>
            <div>
              <!--继承性-->
              C. {{ $t('pc_biz_ote_lbl_quickques04') }}
            </div>
            <div>
              <!--多态性-->
              D. {{ $t('pc_biz_ote_lbl_quickques05') }}
            </div>
            <div>
              <!-- 答案: B -->
              {{ $t('pc_biz_ote_lbl_itemanswer') }}: A C D
            </div>
            <div>
              <!-- 解析: 面向对象特性有封装性、继承性、多态性。 -->
              {{ $t('pc_biz_ote_lbl_quesanalyze') }}:
              {{ $t('pc_biz_ote_lbl_quickquesanalyze1') }}
            </div>
            <br  v-if="quesType=== '-1'"/>
          </div>
          <!--判断题-->
          <div
            v-if="['-1', '2'].includes(quesType)"
            class="yxtbiz-ai-create-ques-temp__ques"
          >
            <div>
              <!-- [判断题][易]原子性是面向对象三大特征之一。-->
              [{{ $t('pc_biz_ote_lbl_questype2') }}][{{
                $t('pc_biz_ote_lbl_easy')
              }}]{{ $t('pc_biz_ote_lbl_quickques08-1') }}
            </div>
            <div>
              <!-- 答案: 错误 -->
              {{ $t('pc_biz_ote_lbl_itemanswer') }}:
              {{ $t('pc_biz_ote_lbl_wrong') }}
            </div>
            <div>
              <!-- 解析: 原子性不是面对对象的特性 -->
              {{ $t('pc_biz_ote_lbl_quesanalyze') }}:
              {{ $t('pc_biz_ote_lbl_quickquesanalyze2') }}
            </div>
            <br  v-if="quesType=== '-1'"/>
          </div>
          <!--填空题-->
          <div
            v-if="['-1', '3'].includes(quesType)"
            class="yxtbiz-ai-create-ques-temp__ques"
          >
            <div>
              <!--[填空题][中]面向对象的特征有( ),( ),( )。-->
              [{{ $t('pc_biz_ote_lbl_questype3') }}][{{
                $t('pc_biz_ote_lbl_medium')
              }}]{{ $t('pc_biz_ote_lbl_quickques07') }}
            </div>
            <div>
              <!-- 答案: 封装性；继承性；多态性 -->
              {{ $t('pc_biz_ote_lbl_itemanswer') }}:
              {{ $t('pc_biz_ote_lbl_quickques02') }}；{{
                $t('pc_biz_ote_lbl_quickques04')
              }}；{{ $t('pc_biz_ote_lbl_quickques05') }}
            </div>
            <div>
              <!-- 解析: 面向对象特性有封装性、继承性、多态性。 -->
              {{ $t('pc_biz_ote_lbl_quesanalyze') }}:
              {{ $t('pc_biz_ote_lbl_quickquesanalyze1') }}
            </div>
            <br  v-if="quesType=== '-1'"/>
          </div>
          <!--问答题-->
          <div
            v-if="['-1', '4'].includes(quesType)"
            class="yxtbiz-ai-create-ques-temp__ques"
          >
            <div>
              <!-- [问答题][难]面向对象的特征包括哪些？-->
              [{{ $t('pc_biz_ote_lbl_questype4') }}][{{
                $t('pc_biz_ote_lbl_difficult')
              }}]{{ $t('pc_biz_ote_lbl_quickques09') }}
            </div>
            <div>
              <!-- 答案: 封装性；继承性；多态性 -->
              {{ $t('pc_biz_ote_lbl_itemanswer') }}:
              {{ $t('pc_biz_ote_lbl_quickques02') }}；{{
                $t('pc_biz_ote_lbl_quickques04')
              }}；{{ $t('pc_biz_ote_lbl_quickques05') }}
            </div>
            <div>
              <!-- 解析: 面向对象特性有封装性、继承性、多态性。 -->
              {{ $t('pc_biz_ote_lbl_quesanalyze') }}:
              {{ $t('pc_biz_ote_lbl_quickquesanalyze1') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </yxt-drawer>
</template>
<script>
import { QUES_TYPE_NAMES } from '../../const';
export default {
  name: 'quesStandardFormatExample',
  props: ['states'],
  data() {
    return {
      QUES_TYPE_NAMES,
      direction: 'rtl',
      drawer: true,
      quesType: '-1',
      isShowMore: true,
      quickTips: this.$t('pc_biz_ote_lbl_quickquestips').split('\n')
    };
  },
  watch: {
    'states.isShowStandardFormatExample'() {
      setTimeout(() => {
        // 组件暂时不支持弹出抽屉后侧边还能操作，这里通过调整样式兼容
        const drawerExample = this.$refs.drawerExample.$el;
        if (drawerExample) {
          drawerExample.style.left = 'auto';
          drawerExample.style.width = 640 + 30 + 'px';
        }
      });
    }
  },
  methods: {
    close() {
      this.drawer = false;
      this.$emit('closeStandardFormatExample');
    },
    handleClick() {}
  }
};
</script>
